import mimeTypes from "../enums/mimeType";

export default async function downloadBase64File(base64, fileName, extension) {
  const mimeType = mimeTypes[extension];

  fetch(`data:${mimeType};base64,${base64}`)
    .then(res => res.blob())
    .then(blob => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(url);
    });

    return true;
}